import Reveal from "@/components/Reveal";
import Cta from "@/components/Cta";
import { Icon } from "@/components/Icon";
import { BOOKKEEPING_FEATURE } from "@/lib/content";
import { IMAGES } from "@/lib/content";

const points = ["Recording & reconciliation", "Clear monthly reports", "Secure cloud access", "Fixed monthly pricing"];

const BookkeepingFeature = () => {
  return (
    <section className="bg-[#F5F6FB]" data-testid="bookkeeping-feature">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-6 order-2 lg:order-1">
            <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
              {BOOKKEEPING_FEATURE.overline}
            </p>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
              {BOOKKEEPING_FEATURE.heading}
            </h2>
            <p className="mt-6 text-lg text-[#51607A] leading-relaxed">
              {BOOKKEEPING_FEATURE.text}
            </p>
            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {points.map((p) => (
                <li key={p} className="flex items-center gap-3 text-base text-[#2A2E7A] font-medium">
                  <Icon name="Check" className="h-5 w-5 text-[#4B5CAB]" strokeWidth={2.25} />
                  {p}
                </li>
              ))}
            </ul>
            <div className="mt-9">
              <Cta to="/services" variant="primary" withArrow testId="bookkeeping-feature-cta">
                {BOOKKEEPING_FEATURE.cta}
              </Cta>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-6 order-1 lg:order-2">
            <div className="rounded-lg overflow-hidden shadow-[0_20px_50px_-24px_rgba(36,59,99,0.3)] border border-[#2A2E7A]/5">
              <img
                src={IMAGES.bookkeeping}
                alt="Aruban Florin banknotes being counted in a money counter"
                className="w-full h-[380px] lg:h-[460px] object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default BookkeepingFeature;
